import { 
    AP_DATA_USAGE_GRAPH_API_FAIL,
	AP_DATA_USAGE_GRAPH_API_SUCCESS,
	AP_DATA_USAGE_GRAPH_API_REQUEST,
	AP_MIN_DATA_USAGE_GRAPH_API_REQUEST,
	AP_MIN_DATA_USAGE_GRAPH_API_SUCCESS,
	AP_MIN_DATA_USAGE_GRAPH_API_FAIL,
	AP_MIN_CLIENT_API_FAIL,
	AP_MIN_CLIENT_API_REQUEST,
	AP_MIN_CLIENT_API_SUCCESS,
	AP_MAX_CLIENT_API_FAIL,
	AP_MAX_CLIENT_API_SUCCESS,
	AP_MAX_CLIENT_API_REQUEST,
	VENDOR_MODEL_API_SUCCESS,
	VENDOR_MODEL_API_FAIL,
	VENDOR_MODEL_API_REQUEST,
	AP_SSID_CLIENT_COUNT_API_FAIL,
    AP_SSID_CLIENT_COUNT_API_REQUEST,
    AP_SSID_CLIENT_COUNT_API_SUCCESS,
    AP_SSID_DATA_USAGE_API_FAIL,
    AP_SSID_DATA_USAGE_API_REQUEST,
    AP_SSID_DATA_USAGE_API_SUCCESS,
    AP_UPTIME_API_FAIL,
    AP_UPTIME_API_REQUEST,
    AP_UPTIME_API_SUCCESS,
 } from "../../constants/graphConstants/homeDashboardGraphConstant";

/**
 * Reducer function for managing site dashboard  SSID load graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const homeDashboardGraphReducer = (
	state = {
        apMaxDataUsage : {
            loading: false,
            data:[],
            error : null
		},
		apMinDataUsage : {
            loading: false,
            data:[],
            error : null
		},
		apMaxCriticalAlarm : {
            loading: false,
            data:[],
            error : null
		},
		apMinCriticalAlarm : {
            loading: false,
            data:[],
            error : null
		},
		vendorModels : {
            loading: false,
            data:[],
            error : null
		},
		apSSIDDataUsage : {
            loading: false,
            data:[],
            error : null
		},
		apSSIDClientCount : {
            loading: false,
            data:[],
            error : null
		},
		apUptime : {
            loading: false,
            data:[],
            error : null
        }
	},
	action
) => {
	switch (action.type) {
		case AP_DATA_USAGE_GRAPH_API_REQUEST:
			return {
				...state,
				apMaxDataUsage : {
                    loading: true,
                    data:[],
                    error : null
                }
			};
		case AP_DATA_USAGE_GRAPH_API_SUCCESS:
			return {
				...state,
				apMaxDataUsage: {
                    loading: false,
                    data: action.payload,
                    error: null
                }
			};
		case AP_DATA_USAGE_GRAPH_API_FAIL:
			return {
                ...state,
                apMaxDataUsage : {
                    loading: false,
                    data:[],
                    error : action.payload
                }
			};
		case AP_MIN_DATA_USAGE_GRAPH_API_REQUEST:
			return {
				...state,
				apMinDataUsage : {
					loading: true,
					data:[],
					error : null
				}
			};
		case AP_MIN_DATA_USAGE_GRAPH_API_SUCCESS:
			return {
				...state,
				apMinDataUsage: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case AP_MIN_DATA_USAGE_GRAPH_API_FAIL:
			return {
				...state,
				apMinDataUsage : {
					loading: false,
					data:[],
					error : action.payload
				}
			};	
		case AP_MIN_CLIENT_API_REQUEST:
			return {
				...state,
				apMinCriticalAlarm : {
					loading: true,
					data:[],
					error : null
				}
			};
		case AP_MIN_CLIENT_API_SUCCESS:
			return {
				...state,
				apMinCriticalAlarm: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case AP_MIN_CLIENT_API_FAIL:
			return {
				...state,
				apMinCriticalAlarm : {
					loading: false,
					data:[],
					error : action.payload
				}
			};
		case AP_MAX_CLIENT_API_REQUEST:
			return {
				...state,
				apMaxCriticalAlarm : {
					loading: true,
					data:[],
					error : null
				}
			};
		case AP_MAX_CLIENT_API_SUCCESS:
			return {
				...state,
				apMaxCriticalAlarm: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case AP_MAX_CLIENT_API_FAIL:
			return {
				...state,
				apMaxCriticalAlarm : {
					loading: false,
					data:[],
					error : action.payload
				}
			};	
		case VENDOR_MODEL_API_REQUEST:
			return {
				...state,
				vendorModels : {
					loading: true,
					data:[],
					error : null
				}
			};
		case VENDOR_MODEL_API_SUCCESS:
			return {
				...state,
				vendorModels: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case VENDOR_MODEL_API_FAIL:
			return {
				...state,
				vendorModels : {
					loading: false,
					data:[],
					error : action.payload
				}
			};	
		case AP_SSID_DATA_USAGE_API_REQUEST:
			return {
				...state,
				apSSIDDataUsage : {
					loading: true,
					data:[],
					error : null
				}
			};
		case AP_SSID_DATA_USAGE_API_SUCCESS:
			return {
				...state,
				apSSIDDataUsage: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case AP_SSID_DATA_USAGE_API_FAIL:
			return {
				...state,
				apSSIDDataUsage : {
					loading: false,
					data:[],
					error : action.payload
				}
			};	
		case AP_SSID_CLIENT_COUNT_API_REQUEST:
			return {
				...state,
				apSSIDClientCount : {
					loading: true,
					data:[],
					error : null
				}
			};
		case AP_SSID_CLIENT_COUNT_API_SUCCESS:
			return {
				...state,
				apSSIDClientCount: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case AP_SSID_CLIENT_COUNT_API_FAIL:
			return {
				...state,
				apSSIDClientCount : {
					loading: false,
					data:[],
					error : action.payload
				}
			};	
		case AP_UPTIME_API_REQUEST:
			return {
				...state,
				apUptime : {
					loading: true,
					data:[],
					error : null
				}
			};
		case AP_UPTIME_API_SUCCESS:
			return {
				...state,
				apUptime: {
					loading: false,
					data: action.payload,
					error: null
				}
			};
		case AP_UPTIME_API_FAIL:
			return {
				...state,
				apUptime : {
					loading: false,
					data:[],
					error : action.payload
				}
			};	
		default:
			return state;
	}
};